// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1jLFl","topBottomGutter":"Layout_topBottomGutter__3YO3S"};